module.exports = __webpack_public_path__ + "media/images/flags/sy-6f4bc8663dcd1dc328dc150970077d71.svg";